<template>
  <div>
    <job-preview-right-column
      :text-count-mode="textCountMode"
      :highlight-mode="highlightMode"
      comment-class="feature"
      :comment-highlights="commentHighlights"
      v-on="$listeners"
    />
    <div class="feature-block fll">
      <p class="h-style-03 fs13 fwB">
        働く環境の特徴
      </p>
      <div class="environment">
        <img
          class="environment-background"
          :src="`${userOfferImageUrlForPc}/environment_bg.png`"
          data-test="environment-background"
        >
        <ul>
          <li
            v-for="environment in requirements.features.environments"
            :id="targetIdMap.feature.environment[environment.id]"
            :key="`environment-star-${environment.id}`"
            :class="`enviro-star-0${environment.name}`"
            :data-test="`environment-star-${environment.id}`"
          >
            <img :src="`${userOfferImageUrlForPc}/feature_star_img.png`">
          </li>
        </ul>
      </div>
    </div>
    <div class="feature-block flr">
      <p class="h-style-03 fs13 fwB">
        この仕事の特徴
      </p>
      <div class="work-feature">
        <img
          class="work-feature-background"
          :src="`${userOfferImageUrlForPc}/work_feature_bg.png`"
          data-test="work-feature-background"
        >
        <ul>
          <li
            v-for="work in requirements.features.work"
            :id="targetIdMap.feature.work[work.id]"
            :key="`work-feature-bar-${work.id}`"
            :data-test="`work-feature-bar-${work.id}`"
          >
            <span :class="`work-feature-bar-0${work.name}`" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewRightColumn from '@/components/molecules/JobPreviewRightColumn'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewHighlight from '@/lib/jobPreviewHighlight'

export default {
  components: {
    JobPreviewRightColumn
  },
  mixins: [jobPreviewCommon, jobPreviewHighlight],
  props: {
    requirements: {
      type: Object,
      default: () => {}
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      required: true
    },
    textCountMode: {
      type: Boolean,
      required: true
    }
  }
}
</script>
